import React from 'react';
import {  List, ListItem, ListItemIcon, ListItemText, Divider, Grid } from '@mui/material';
import { WSIcons } from '../../commonFunctions/iIcons';

const Sidebar: React.FC = () => {
  return (
    <Grid
      sx={{
        width: '15%',
        background: '#9c27b0',
        padding: '20px',
        color: '#fff',
        height: '100vh',
        
      }}
    >
      <List>
        <ListItem
          button
          sx={{
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <ListItemIcon sx={{ minWidth: 0 }}>
            <WSIcons.AddIcon style={{ color: '#fff' }} />
          </ListItemIcon>
          <ListItemText primary="Yeni" />
        </ListItem>
        <Divider />
        <ListItem
          button
          sx={{
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <ListItemIcon sx={{ minWidth: 0 }}>
            <WSIcons.CardGiftcardIcon style={{ color: '#fff' }} />
          </ListItemIcon>
          <ListItemText primary="İkram" />
        </ListItem>
        <Divider />
        <ListItem
          button
          sx={{
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <ListItemIcon sx={{ minWidth: 0 }}>
            <WSIcons.SyncIcon style={{ color: '#fff' }} />
          </ListItemIcon>
          <ListItemText primary="İade" />
        </ListItem >
        <Divider />
        {/* Repeat for other list items */}
        <ListItem sx={{
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}>
          <ListItemIcon sx={{ minWidth: 0 }}>
            <WSIcons.AltRouteIcon style={{ color: '#fff' }} />
          </ListItemIcon>
          <ListItemText primary="bol" />
        </ListItem>
        <Divider />

        <ListItem sx={{
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}>
          <ListItemIcon sx={{ minWidth: 0 }}>
            <WSIcons.Tag style={{ color: '#fff' }} />
          </ListItemIcon>
          <ListItemText primary="iklondo" />
        </ListItem>
        <Divider />

        <ListItem sx={{
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}>
          <ListItemIcon sx={{ minWidth: 0 }}>
            <WSIcons.PrintIcon style={{ color: '#fff' }} />
          </ListItemIcon>
          <ListItemText primary="yosdir" />
        </ListItem>
        <Divider />

        <ListItem sx={{
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}>
          <ListItemIcon sx={{ minWidth: 0 }}>
            <WSIcons.CancelIcon style={{ color: '#fff' }} />
          </ListItemIcon>
          <ListItemText primary="ipdar" />
        </ListItem>
        <Divider />

        <ListItem sx={{
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}>
          <ListItemIcon sx={{ minWidth: 0 }}>
            <WSIcons.ReplyIcon style={{ color: '#fff' }} />
          </ListItemIcon>
          <ListItemText primary="tasi" />
        </ListItem>
        <Divider />

      </List>    </Grid>
  );
};

export default Sidebar;
